import { PRESENTATION_TYPE } from "src/Pages/Company/Absences/AbsenceRecords/AbsenceRecords.models";
import { EPatternUnit } from "src/Pages/Company/Absences/AbsenceType/AbsenceType.models";
import formatDayLabel from "./formatDayLabel";

interface IBalanceCountInput {
  days?: number;
  hours?: number;
  presentationType?: PRESENTATION_TYPE;
  billingCycle?: EPatternUnit;
}

/**
 * Formats the display text for an absence balance count (e.g. "3 dni / 24h")
 * based on the presentation type / billing cycle configuration.
 * Falls back to the translated "brak limitu" text when no days/hours are set,
 * and to an empty string when no known combination matches.
 */
export default ({
  days,
  hours,
  presentationType,
  billingCycle,
}: IBalanceCountInput): string => {
  if (days === undefined && hours === undefined) {
    return "brak limitu";
  }

  switch (true) {
    case presentationType === PRESENTATION_TYPE.DAYS_AND_HOURS:
      return `${days} ${formatDayLabel(days!)} / ${hours}h`;
    case presentationType === PRESENTATION_TYPE.DAYS_OR_HOURS:
      return `${days} ${formatDayLabel(days!)} lub ${hours}h`;
    case presentationType === PRESENTATION_TYPE.DAYS ||
      billingCycle === EPatternUnit.Day:
      return `${days} ${formatDayLabel(days!)}`;
    case presentationType === PRESENTATION_TYPE.HOURS ||
      billingCycle === EPatternUnit.Hour:
      return `${hours}h`;
    default:
      return "";
  }
};
